module.exports = __webpack_public_path__ + "img/resources-768.30ae1536.jpg";